// import { Component, OnInit } from '@angular/core';
// import { FacebookService, InitParams } from 'ngx-facebook';
// import { Title, Meta } from '@angular/platform-browser'; 

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
//   styleUrls: ['./app.component.css']
// })
// export class AppComponent implements OnInit{
//   title = 'lineclear';

//   constructor(
//     private facebookService: FacebookService,
//     private metaService: Meta,
//     private titleService: Title
//   ) { }

//   ngOnInit(): void {
//     this.initFacebookService();

//     this.titleService.setTitle("Scan 2 Delivery Express Malaysia | Line Clear Express")

//     const metaDesc = this.metaService.getTag('name=description'); 

//     if(!metaDesc){

//         this.metaService.addTags([
//             {name: "description", content: "Provides nationwide courier and  integrated supply chain management solutions from warehousing, pick and pack, last mile delivery and track and trace. Customers are empowered through the Line Clear's smart Scan2Deliver technology to make end-to-end delivery using the web or app."}
//         ]);
//     }else{

//         this.metaService.updateTag(  
//             { name: "description", content: "Provides nationwide courier and  integrated supply chain management solutions from warehousing, pick and pack, last mile delivery and track and trace. Customers are empowered through the Line Clear's smart Scan2Deliver technology to make end-to-end delivery using the web or app." },  
//             "name=description"  
//           )  
//     }
//   }

//   private initFacebookService(): void {
//     const initParams: InitParams = { xfbml:true, version:'v3.2'};
//     this.facebookService.init(initParams);
//   }

// }


import { Component, ViewChild } from '@angular/core';
import { LiveChatWidgetModel, LiveChatWidgetApiModel, LivechatWidgetComponent} from '@livechat/angular-widget';
import { Title, Meta } from '@angular/platform-browser'; 

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public isLiveChatWidgetLoaded: boolean = false;
  public liveChatApi: LiveChatWidgetApiModel;
  // public visitor: { name: string; email: string, phone: string};
  // public params: { name: string; value: string}[];
  title = 'lineclear';

  @ViewChild('liveChatWidget', {static: false}) public liveChatWidget: LiveChatWidgetModel;

  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle("Scan 2 Delivery Express Malaysia | Line Clear Express");
    
    const metaDesc = this.metaService.getTag('name=description'); 

    if(!metaDesc){

        this.metaService.addTags([
            {name: "description", content: "Provides nationwide courier and  integrated supply chain management solutions from warehousing, pick and pack, last mile delivery and track and trace. Customers are empowered through the Line Clear's smart Scan2Deliver technology to make end-to-end delivery using the web or app."}
        ]);
    }else{

        this.metaService.updateTag(  
            { name: "description", content: "Provides nationwide courier and  integrated supply chain management solutions from warehousing, pick and pack, last mile delivery and track and trace. Customers are empowered through the Line Clear's smart Scan2Deliver technology to make end-to-end delivery using the web or app." },  
            "name=description"  
          )  
    }
  
    
  }

  
  onChatLoaded(api: LiveChatWidgetApiModel): void {
    this.liveChatApi = api;
    this.isLiveChatWidgetLoaded = true;
  
    // Sometimes it can happen that LC_Invite is is still being loaded when onChatLoaded is called. To ensure that LC_Invite is loaded you can give additional check to onChatLoaded function:
    // api.on_after_load = () => {
    //   this.liveChatApi = api;
    //   this.isLiveChatWidgetLoaded = true;
    // };
  }


  // onChatWindowMinimized() {
  //   console.log('minimized')
  // }

  // onChatWindowOpened() {
  //   console.log('opened')
    
  // }

  // openChatWindow(): void {
  //   if (this.isLiveChatWidgetLoaded) {
  //     this.liveChatWidget.openChatWindow();

  //     // You can also use methods directly on liveChatApi instance
  //     // for more details plese read our documentation 
  //     // https://developers.livechatinc.com/docs/extending-ui/extending-chat-widget/javascript-api/#methods
  //     // this.liveChatApi.open_chat_window();

      



  //   };
  // }

  // hideChatWindow() {
  //   if (this.isLiveChatWidgetLoaded) {
  //     this.liveChatWidget.minimizeChatWindow();

  //     // You can also use methods directly on liveChatApi instance
  //     // for more details plese read our documentation 
  //     // https://developers.livechatinc.com/docs/extending-ui/extending-chat-widget/javascript-api/#methods
  //     // this.liveChatApi.minimize_chat_window();
  //   };
  // }


  //----get customer data
  // onPrechatSurveySubmitted(api: LiveChatWidgetApiModel): void {
  //     // var customer = api|| {};
  //     //     api.on_prechat_survey_submitted = function(data){
  //     //       var customer_data = data.form_data.map(function(formData: { label: string; value: string; }) {
  //     //         return formData.label + ": " + formData.value;
  //     //       })
  //     //       .join("\n");
  //     //     alert(customer_data);
  //     //   };
  //     var form_data
  //     var customer = api || {};
  //     for(var index in customer){
  //       form_data = customer[index]
  //     }
  //     console.log(form_data);

  //   }
  
  


}
